import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, forwardRef, Provider, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { PaymentTypeService } from '../shared/payment-types/payment-type.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../shared/util/util.service';
import {
  NumberValueAccessor,
  CreateNumberValueAccessorProvider,
  CreateNumberValueValidationProvider,
} from '../../shared/widgets/value-accessors/number-value-accessor';
import { PaymentTypeDto } from '../shared/payment-types/dto/payment-type.dto';

@Component({
  selector: 'wl-payment-type-selector',
  templateUrl: 'payment-type-selector.component.html',
  styleUrls: ['payment-type-selector.component.css'],
  providers: [
    PaymentTypeService,
    CreateNumberValueAccessorProvider(PaymentTypeSelectorComponent),
    CreateNumberValueValidationProvider(PaymentTypeSelectorComponent),
  ],
  standalone: false
})
export class PaymentTypeSelectorComponent extends NumberValueAccessor implements OnInit, OnChanges {
  @Input() includeNoneValue: boolean = true;
  @Input() noneValueDisplay: string = '';
  @Input() revenueItemNum: number = 0;
  @Input() accountingPackageId: number = 0;
  /*
   * Optional. Restrict results to or omit credit card types. Default does not apply any filter.
   */
  @Input() creditCardType?: boolean;

  //for validation to know if 0 an be allowed
  @Input() required: any;

  @Output() onPaymentTypeChanged = new EventEmitter<PaymentTypeDto>();

  public _paymentTypeService: PaymentTypeService;
  public _translateService: TranslateService;
  public _utilService: UtilService;
  public _noneText: string;

  public paymentTypes: Array<PaymentTypeDto>;

  public constructor(paymentTypeService: PaymentTypeService, translateService: TranslateService, utilService: UtilService) {
    super();
    this._paymentTypeService = paymentTypeService;
    this._translateService = translateService;
    this._utilService = utilService;
    this._noneText = '';

    this.paymentTypes = new Array<PaymentTypeDto>();
    this.revenueItemNum = 0;
  }

  //this overrides the base class function to set
  //what it means for this this control to be valid
  isValid = (): boolean => {
    if (this._utilService.isNotNullOrUndefined(this.required)) {
      if (this.value > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  ngOnInit() {
    this.loadPaymentTypes();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.loadPaymentTypes();
  }

  modelChange(data: string) {
    //the data comes thru as a string convert to int
    this.value = parseInt(data);

    this.emitOutputObject();
  }

  loadPaymentTypes = (): void => {
    if (this.revenueItemNum > 0) {
      this._paymentTypeService.getPaymentTypesForRevenueItem(this.revenueItemNum).then((data: Array<PaymentTypeDto>) => {
        this.paymentTypeDataCallBack(data);
      });
    } else if (this.accountingPackageId > 0) {
      this._paymentTypeService.getPaymentTypesForAccountingPackage(this.accountingPackageId).then((data: Array<PaymentTypeDto>) => {
        this.paymentTypeDataCallBack(data);
      });
    } else {
      this._paymentTypeService.getPaymentTypes().then((data: Array<PaymentTypeDto>) => {
        this.paymentTypeDataCallBack(data);
      });
    }
  };

  paymentTypeDataCallBack = (data: Array<PaymentTypeDto>): void => {
    if (this.creditCardType != null)
      data = data.filter(x => {
        return x.CreditCardType == this.creditCardType;
      });

    this.paymentTypes = data;

    this.paymentTypeAddNone(this.paymentTypes).then((data: Array<PaymentTypeDto>): void => {
      let filter: Array<PaymentTypeDto> = this.paymentTypes.filter(item => {
        return item.PaymentTypeId == this.value;
      });
      if (filter.length == 0) {
        //the currently selected PaymentTypeId is not in the list of avail paymenttypes
        this.value = 0;
      }

      this.emitOutputObject();
    });
  };

  paymentTypeAddNone = (data: Array<PaymentTypeDto>): Promise<Array<PaymentTypeDto>> => {
    if (this.includeNoneValue == true) {
      let noneItem = {} as PaymentTypeDto;
      noneItem.PaymentTypeId = 0;

      if (this._utilService.isNotNullEmptyOrWhitespace(this.noneValueDisplay)) {
        this._noneText = this.noneValueDisplay;

        noneItem.PaymentType = this._noneText;
        this.paymentTypes.splice(0, 0, noneItem);
        return Promise.resolve(this.paymentTypes);
      } else {
        return this._translateService
          .get('common.none')
          .toPromise()
          .then((result: string) => {
            this._noneText = this._utilService.toTitleCase(result);
            noneItem.PaymentType = this._noneText;
            this.paymentTypes.splice(0, 0, noneItem);
            return Promise.resolve(this.paymentTypes);
          });
      }
    } else {
      return Promise.resolve(this.paymentTypes);
    }
  };

  emitOutputObject = (): void => {
    let filter: Array<PaymentTypeDto> = this.paymentTypes.filter(item => {
      return item.PaymentTypeId == this.value;
    });
    if (filter.length > 0) {
      //emit the selected rev item full object
      this.onPaymentTypeChanged.emit(filter[0]);
    }
  };
}
